export const REF_DOC_PATH = "/refdoc";
export const REPORT_PATH = "/report_detail";
export const DASHBOARD_PATH = "/dashboard";
export const STIXSEARCH_PATH = "/stixsearch";
export const GRAPHSEARCH_PATH = "/graphsearch";
export const UPLOAD_PATH = "/upload";
export const CONCEPTNETWORK_PATH = "/conceptnetwork";
export const HOME_PATH = "/";
export const NOT_FOUND = "/not-found";